export function sliderReports() {
    let $slider = $(".slider-reports");

    $slider.each(function () {
        let $this = $(this),
        $holder = $this.closest('.wrap-slider-reports');

        $this.slick({
            arrows: true,
            infinite: true,
            fade: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 8000,
            speed: 500,
            pauseOnHover: true,
            pauseOnFocus: true,
            prevArrow: $holder.find(".common-slider-controls .prev-arrow"),
            nextArrow: $holder.find(".common-slider-controls .next-arrow"),
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        fade: false
                    }
                },
            ]
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/sliderReports.js